import React from "react";
import DeviceShowcase from "../DeviceShowcase";

export default function FinanceMockup() {
  const desktopUI = (
    <div className="w-full h-full flex flex-col text-sm bg-white">
      <div className="bg-slate-50 border-b border-slate-200 p-2 md:p-3 flex items-center justify-between">
        <span className="font-semibold text-slate-700 text-xs md:text-sm">
          Bảng Đối Soát Công Nợ T5/2026
        </span>
        <span className="px-2 py-1 bg-green-100 text-green-700 rounded text-[10px] md:text-xs font-medium border border-green-200">
          Kỳ Kế Toán: Tháng 5
        </span>
      </div>
      <div className="p-3 md:p-4 flex-1 flex flex-col gap-4 overflow-auto">
        <div className="flex gap-4 p-3 bg-indigo-50/50 border border-indigo-100 rounded-lg">
          <div className="w-12 h-12 rounded bg-indigo-100 text-indigo-600 flex flex-col items-center justify-center">
            <span className="text-xs font-bold">VIP</span>
          </div>
          <div className="flex-1 flex flex-col justify-center">
            <div className="font-bold text-slate-800 text-sm md:text-base">
              Công ty CP Dược Phẩm Á Âu
            </div>
            <div className="text-[10px] md:text-xs text-slate-500 mt-0.5">
              Tổng Nợ Cũ: 150,000,000 đ | Hạn Mức Tín Dụng: 500 Triệu
            </div>
          </div>
        </div>

        <div className="space-y-2">
          <div className="border border-slate-200 rounded-md overflow-hidden shadow-sm">
            <table className="w-full text-left">
              <thead className="bg-slate-50 border-b border-slate-200 text-[10px] md:text-[11px] text-slate-500 uppercase tracking-wider">
                <tr>
                  <th className="p-2 font-medium">Chứng từ</th>
                  <th className="p-2 font-medium text-right">Giá Trị ĐH</th>
                  <th className="p-2 font-medium text-right text-green-600">
                    Đã Thu
                  </th>
                  <th className="p-2 font-medium text-right text-red-600">
                    Cấn trừ (NCR)
                  </th>
                  <th className="p-2 font-medium text-right">Còn Lại</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100 text-[10px] md:text-xs">
                <tr>
                  <td className="p-2">
                    <div className="font-bold text-slate-700">INV-2605-01</div>
                    <div className="text-[9px] text-slate-400">
                      Hộp Mỹ Phẩm Trắng Da
                    </div>
                  </td>
                  <td className="p-2 text-right">80,350,000 đ</td>
                  <td className="p-2 text-right text-green-600 font-medium">
                    40,000,000 đ{" "}
                    <span className="block text-[9px] text-green-400 font-normal">
                      (Cọc 50%)
                    </span>
                  </td>
                  <td className="p-2 text-right text-red-500">-</td>
                  <td className="p-2 text-right font-bold text-slate-800">
                    40,350,000 đ
                  </td>
                </tr>
                <tr>
                  <td className="p-2">
                    <div className="font-bold text-slate-700">INV-2604-55</div>
                    <div className="text-[9px] text-slate-400">
                      Tem Nhãn Decal Cuộn
                    </div>
                  </td>
                  <td className="p-2 text-right">15,000,000 đ</td>
                  <td className="p-2 text-right text-green-600 font-medium">
                    0 đ
                  </td>
                  <td className="p-2 text-right text-red-600 font-medium">
                    500,000 đ{" "}
                    <span className="block text-[9px] text-red-400 font-normal">
                      (Đứt cuộn)
                    </span>
                  </td>
                  <td className="p-2 text-right font-bold text-slate-800">
                    14,500,000 đ
                  </td>
                </tr>
                <tr className="bg-slate-50 border-t-2 border-slate-200">
                  <td className="p-2 font-bold text-slate-700 text-right">
                    TỔNG PHÁT SINH KỲ NÀY
                  </td>
                  <td className="p-2 text-right font-bold">95,350,000 đ</td>
                  <td className="p-2 text-right font-bold text-green-600">
                    40,000,000 đ
                  </td>
                  <td className="p-2 text-right font-bold text-red-600">
                    500,000 đ
                  </td>
                  <td className="p-2 text-right font-bold text-indigo-700 text-sm">
                    54,850,000 đ
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="flex justify-end gap-2 mt-2">
          <button className="px-3 py-1.5 border border-slate-200 text-slate-600 rounded text-xs font-medium hover:bg-slate-50">
            Xuất PDF
          </button>
          <button className="px-3 py-1.5 bg-indigo-600 text-white rounded text-xs font-medium hover:bg-indigo-700 shadow-sm">
            Chốt Công Nợ & Gửi Khách Hàng
          </button>
        </div>
      </div>
    </div>
  );

  const mobileUI = (
    <div className="w-full h-full flex flex-col bg-slate-50">
      <div className="bg-emerald-600 text-white p-4 rounded-b-2xl shadow-md z-10 relative">
        <div className="text-[10px] uppercase tracking-wider mb-2 opacity-80 font-medium">
          Tổng Thu Tháng 5
        </div>
        <div className="text-2xl font-bold mb-4">4,250,000,000 đ</div>
        <div className="flex justify-between items-end border-t border-emerald-500/50 pt-2">
          <div>
            <div className="text-[9px] opacity-80 mb-0.5">Tổng Chi</div>
            <div className="text-xs font-bold text-emerald-100">
              1,820,000,000 đ
            </div>
          </div>
          <div className="text-right">
            <div className="text-[9px] opacity-80 mb-0.5">Dòng Tiền Thuần</div>
            <div className="text-sm font-bold text-white">+2.43 Tỷ</div>
          </div>
        </div>
      </div>

      <div className="flex-1 p-3 overflow-y-auto space-y-3 -mt-2 pt-5">
        <div className="flex items-center justify-between px-1 mb-1">
          <span className="text-[10px] font-bold text-slate-500 uppercase tracking-wider">
            Phiếu Chi Chờ Duyệt (2)
          </span>
        </div>

        <div className="bg-white p-3 rounded-xl border border-slate-200 shadow-sm relative">
          <div className="absolute top-0 right-0 w-2 h-full bg-amber-400 rounded-r-xl"></div>
          <div className="flex justify-between items-start mb-2">
            <div>
              <div className="text-xs font-bold text-slate-800">
                Thanh Toán Tiền Giấy Bãi Bằng
              </div>
              <div className="text-[10px] text-slate-500">
                Kế toán: Lê Thị C - Hôm nay
              </div>
            </div>
          </div>
          <div className="text-lg font-bold text-amber-600 mb-2">
            145,000,000 đ
          </div>
          <div className="flex gap-2">
            <button className="flex-1 border border-slate-200 text-slate-600 py-1.5 rounded-lg text-xs font-bold bg-slate-50">
              Chi Tiết
            </button>
            <button className="flex-1 bg-amber-500 text-white py-1.5 rounded-lg text-xs font-bold shadow-sm shadow-amber-200">
              Duyệt Chi
            </button>
          </div>
        </div>

        <div className="bg-white p-3 rounded-xl border border-slate-200 shadow-sm relative">
          <div className="absolute top-0 right-0 w-2 h-full bg-slate-300 rounded-r-xl"></div>
          <div className="flex justify-between items-start mb-2">
            <div>
              <div className="text-xs font-bold text-slate-800">
                Thanh Toán Gia Công Phủ UV
              </div>
              <div className="text-[10px] text-slate-500">
                Kế toán: Lê Thị C - Hôm qua
              </div>
            </div>
          </div>
          <div className="text-lg font-bold text-slate-600 mb-2">
            20,000,000 đ
          </div>
        </div>
      </div>
    </div>
  );

  return <DeviceShowcase desktopUI={desktopUI} mobileUI={mobileUI} />;
}
